module.exports = "<mat-card>\r\n    <h2>Time Balance Mail</h2>\r\n    <p style=\"font-style: italic;\">\r\n        This feature is not available.\r\n    </p>\r\n</mat-card>"


//////////////////
// WEBPACK FOOTER
// ./client/app/activities/time-balance-mail.component.html
// module id = 1169
// module chunks = 1